(() => {
  const SECTION_SELECTOR = '[data-history-timeline]';
  const TRACK_SELECTOR = '[data-history-timeline-track]';
  const CARD_SELECTOR = '[data-history-timeline-card]';
  const FLAG = 'historyTimelineInit';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function waitForGsap(cb) {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
      cb();
    } else {
      requestAnimationFrame(() => waitForGsap(cb));
    }
  }

  function initSection(section) {
    if (section.dataset[FLAG] === '1') return;
    section.dataset[FLAG] = '1';

    const track = section.querySelector(TRACK_SELECTOR);
    const cards = Array.from(section.querySelectorAll(CARD_SELECTOR));
    if (!track || cards.length === 0) return;

    const reduced = prefersReducedMotion();

    // Card reveal — window-flap hinge, one-shot
    const mqMobile = window.matchMedia('(max-width: 749px)');

    cards.forEach((cardWrap) => {
      const cardEl = cardWrap.querySelector('.history-timeline__card') || cardWrap;

      if (reduced) {
        gsap.set(cardEl, { opacity: 1, rotateY: 0, rotateX: 0 });
        return;
      }

      const isLeft = cardEl.classList.contains('history-timeline__card--left');

      const applyFromState = () => {
        if (mqMobile.matches) {
          gsap.set(cardEl, {
            transformOrigin: 'center top',
            transformPerspective: 1200,
            opacity: 0,
            rotateX: -95,
            rotateY: 0,
            z: -180,
            y: -20,
          });
        } else if (isLeft) {
          gsap.set(cardEl, {
            transformOrigin: 'right center',
            transformPerspective: 1200,
            opacity: 0,
            rotateX: 6,
            rotateY: -110,
            z: -220,
            x: 40,
          });
        } else {
          gsap.set(cardEl, {
            transformOrigin: 'left center',
            transformPerspective: 1200,
            opacity: 0,
            rotateX: 6,
            rotateY: 110,
            z: -220,
            x: -40,
          });
        }
      };
      applyFromState();

      ScrollTrigger.create({
        trigger: cardWrap,
        start: 'top 80%',
        once: true,
        onEnter() {
          gsap.to(cardEl, {
            opacity: 1,
            rotateX: 0,
            rotateY: 0,
            x: 0,
            y: 0,
            z: 0,
            duration: 0.95,
            delay: 0.5,
            ease: 'back.out(1.5)',
          });
        },
      });
    });

    if (reduced) return;

    // Tracker — scrubbed timeline with x+y keyframes anchored to each card
    const firstCard = cards[0];
    const lastCard = cards[cards.length - 1];
    const inner = section.querySelector('.history-timeline__inner');

    const X_BIAS = 2.5; // fraction of the axis→card-center distance (1 = behind card center, 0 = on axis)
    const xFor = (card) => {
      const cardEl = card.querySelector('.history-timeline__card') || card;
      const innerRect = inner.getBoundingClientRect();
      const cardRect = cardEl.getBoundingClientRect();
      const axisX = innerRect.left + innerRect.width / 2;
      const cardCenterX = cardRect.left + cardRect.width / 2;
      return (cardCenterX - axisX) * X_BIAS;
    };

    gsap.set(track, { x: () => xFor(firstCard), y: 0 });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: firstCard,
        endTrigger: lastCard,
        start: 'center center',
        end: 'bottom center+=100%',
        scrub: 0.6,
        invalidateOnRefresh: true,
      },
    });

    cards.slice(1).forEach((card) => {
      tl.to(track, {
        x: () => xFor(card),
        ease: 'none',
      });
    });

    section._historyTrackerTween = tl;
  }

  function killSection(section) {
    if (section._historyTrackerTween) {
      const st = section._historyTrackerTween.scrollTrigger;
      if (st) st.kill();
      section._historyTrackerTween.kill();
      section._historyTrackerTween = null;
    }
    delete section.dataset[FLAG];
  }

  function initAll(root) {
    const ctx = root || document;
    Array.from(ctx.querySelectorAll(SECTION_SELECTOR)).forEach(initSection);
  }

  function onSectionLoad(e) {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  }

  function onSectionUnload(e) {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) killSection(section);
  }

  let resizeTimer = null;
  function onResize() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
    }, 150);
  }

  function boot() {
    waitForGsap(() => {
      initAll(document);
      document.addEventListener('shopify:section:load', onSectionLoad);
      document.addEventListener('shopify:section:unload', onSectionUnload);
      window.addEventListener('resize', onResize, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
